import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pHead",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "pHead-main"
  }, [_c('div', {
    staticClass: "logo btn",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@images/ui/monpop-logo.svg"),
      "alt": "Monpop"
    }
  }), _vm._m(0)]), !_vm.isMobile ? _c('div', {
    staticClass: "pHead-menu"
  }, [_c('p-menu')], 1) : _vm._e(), _c('div', {
    staticClass: "pHead-btns"
  }, [_c('p-head-btns')], 1)]), _vm.isMobile ? _c('div', {
    staticClass: "pHead-menu"
  }, [_c('p-menu')], 1) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_vm._v("MONPOP"), _c('span', [_vm._v(".FUN")])]);
}];
export { render, staticRenderFns };